import {
  connect as adFoxConnect,
  IAdFoxBannerOnLoadData,
  TAdFoxBannerProps as TAdFoxBannerComponentProps,
} from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import { Responsive } from '@cian/ui-kit';
import * as React from 'react';
import { withAdfoxPostViewAnalytics } from '@cian/postview-analytics-utils';

const AdFoxContainerComponent = adFoxConnect(AdFoxTemplates);

type TAdFoxContainerProps = {
  disableYan?: boolean;
} & TAdFoxBannerComponentProps;

export const AdFoxContainer: React.FC<TAdFoxContainerProps> = props => {
  const [hidden, setHidden] = React.useState(false);
  const { disableYan, ...sharedProps } = props;

  const handleLoad = React.useCallback(
    (data: IAdFoxBannerOnLoadData) => {
      const { bundleName } = data;

      if (disableYan && bundleName === 'banner.direct') {
        setHidden(true);
      }
    },
    [disableYan],
  );

  const handleStub = React.useCallback(() => {
    setHidden(true);
  }, []);

  if (disableYan && hidden) {
    return null;
  }

  const bannerProps = {
    ...sharedProps,
    onLoad: handleLoad,
    onStub: handleStub,
  };

  const AdfoxBannerWithPostView = withAdfoxPostViewAnalytics(AdFoxContainerComponent, bannerProps, {
    banner: {
      place: 'header',
      name: 'BuildingProgress_JK_TGB',
    },
  });

  return (
    <Responsive desktop>
      <AdfoxBannerWithPostView />
    </Responsive>
  );
};
